import { TableHeaderType } from "../types/TableHeaderType";

export const CloudEnviromentHeader: TableHeaderType[] = [
    {
      label: 'Provider',
      key: 'provider',
      id: 'provider',
      sortable: true,
    },
    {
      label:'Name',
      key: 'environmentName',
      id: 'environmentName',
      sortable: true,
    },
    {
      label:'Iac',
      key: 'iac',
      id: 'iac',
      sortable: true,
    },
    {
      id: 'environmentDescription',
      label: 'Description',
      sortable: false,
      key: 'environmentDescription',
    },
  ];